import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_GROUPS, PASSWORD_MIN_LENGTH } from '../../utils/constants'

export const verifyPassword = (password) => {
  let numberOfValidations = 0
  const arrayOfValidations = [/\d/, /[a-z]/, /[A-Z]/, /[$&()+'.;=?_-]/]
  const allowedChars = /^[A-Za-z0-9$&()+'.;=?_-]+$/

  if (!password) {
    return false
  }

  if (password.length < PASSWORD_MIN_LENGTH || password.length > PASSWORD_MAX_LENGTH) {
    return false
  }

  // Solo se admiten letras, números y los caracteres especiales de PASSWORD_SPECIAL_CHARS
  if (!allowedChars.test(password)) {
    return false
  }

  for (const regex of arrayOfValidations) {
    if (regex.test(password)) {
      numberOfValidations += 1
    }
  }

  return numberOfValidations >= PASSWORD_MIN_GROUPS
}

export const validateCustomerID = (id) => {
  const regex = /^[0-9]{1,45}$/
  return regex.test(id)
}

export const validateDNI = (dni) => {
  const regex = /^[0-9]{8,8}[A-Z]$/
  return regex.test(dni)
}

export const validateAccount = (account) => {
  const regex = /^([A-Z]{2}(?:[ ]?[0-9]){18,22})$/
  return regex.test(account)
}

export const validateCIF = (cif) => {
  const regex = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/
  return regex.test(cif)
}

export const validateNIE = (cif) => {
  const regex = /^[XYZ][0-9]{7}[A-Z]$/
  return regex.test(cif)
}

export const validateEmail = (email) => {
  const regex = /^[\w.ñÑ!#$%&'*+\-/=?^_`{|}~]+@([\wñÑ-]+\.)+[\w]{2,}$/
  return regex.test(email)
}

export const validatePhone = (phone) => {
  const regex = /^(\+[0-9]{2,2}){0,1}[0-9]{9,9}$/
  return !!phone && regex.test(phone)
}

export const validateBirthDate = (birthDate) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/
  return regex.test(birthDate)
}

export const validateIP = (IP) => {
  const regex = /^\d{3}.\d{2}.\d{2}.\d{2}.\d{2}$/
  return regex.test(IP)
}
export const validateDomain = (domain) => {
  const regex = /^[a-zA-Z]+$/
  return regex.test(domain)
}

export const validateSubdomainDomain = (domain) => {
  const regex = /^[a-zA-Z.]+$/
  return regex.test(domain)
}
